import React from 'react';
import { Image } from 'react-bootstrap';

import './Press.css';

const press = props => (
  <div className="column-container">

    <div className="press-info compact">
      <h3>Press</h3>

      <h4>PRESSRELEASE ”BIOTEATER VÄNNERNA I KUNGASKOGEN”</h4>
      <p>Över 150 000 förskolebarn gått på bioteater (bio eller streamad föreställning) och sett  succèföreställning om vänskap.
Vi i malmö har snart lyckats samla 100 000 förskolebarn till bioteaterföreställningar i hela sverige.
Bioteatern ”Vännerna i kungaskogen” har visats på Bio i över 50 orter i Sverige från Trelleborg i söder till Boden i norr. Numera streamas föreställningarna direkt på förskolor och visas varje tisdag, onsdag och torsdag hela året.
De flesta föreställningar är för det mesta utsålda. Teaterföreställningen handlar om vänskap, respekt för andra och mot utanförskap och mobbning.
Sveriges första digitala barnteater (teater på bioduk eller streamad teater; bioteater) visas nu för tionde året i rad runtom i Sverige.
Intresset från pedagoger och förskolor har varit rekordstort. Förskolebarnen får se när kompisarna ekorren Snick och igelkotten Snack från Kungaskogen ska bygga en kompiskoja. Budskapet i sagan om Vännerna i Kungaskogen är viktigt; ”att vara schysst och en bra kompis”.
Flera av barnviseklassikerna från Kungaskogen framförs och sjungs också i föreställningen. I en av sångerna bjuds alla upp till dans.
De allra bästa musikerna och barnmusikalartisterna medverkar i sångproduktionerna. Föreställningen inleds av skådespelaren Börje Ahlstedt. På Spotify (sökord Kungaskogen, Snick & Snack) finns
alla de sånger som framförs i bok- och musiksagan, Snick och Snack Vännerna i Kungaskogen bygger en koja som över 10 000 förskolor i Sverige från Ystad till Haparanda använder.
Snick och Snack är viktiga förebilder för barnen. Nu kan viktiga värdegrunder tillgängligöras i stora delar av Sverige genom modern digital teknik när teaterversionen av verket ”Vännerna i Kungaskogen” också kan visas var som helst.
Bioteatern Vännerna i Kungaskogen grundar sig på bok och musikverket ”Vännerna i Kungaskogen bygger en koja” som är producerad i Malmö och som gjort succé på förskolor i hela Sverige.</p>

      <h4>Medverkande i bioföreställningen</h4>
      <p>Berättare inledning: Börje Ahlstedt</p>
      <p>Musikalartister: My Johansson, Louisa Lyne och Tobias Kralmark. Regi: Magnus Ödéhn.</p>
      <p>Sång: Ville och Vännerorkestern</p>
      <p>Klippning och redigering: Good World AB Malmö</p>
      <p>Filmning: Solid Entertainment AB Malmö</p>

      <h4>Upphovspersoner till verket vännerna i kungaskogen</h4>
      <p>Text och manus: Lisa dos Santos</p>
      <p>Musik: Lisa dos Santos, Joc Lind, Vilhelm Ersmark</p>
      <p>Förlag: ILKA Förlagsprodukter AB/Wasa Music AB Malmö</p>
      <p>Spotify: använd sökord Kungaskogen, Snick och Snack</p>

      <h4>Kontaktperson</h4>
      <p>040-120012 Ulf</p>
      <p>idea@ilka.se</p>

      <a href="https://www.youtube.com/watch?v=5HDUwImaUkU" target="_blank" rel="noopener noreferrer">
        Trailer Bioteater Kungaskogen
      </a>
      <a href="https://www.youtube.com/watch?v=LfrfYrt8C2c" target="_blank" rel="noopener noreferrer">
        Lyssna när 800 glada barn och vuxna blir vänner med djurkompisarna i kungaskogen
      </a>

      <h4>Åklagare skrev förskolans mest använda sagobok</h4>

      <p>Under pseudonymen Lisa Grane, numera Lisa dos Santos, skrev Lisa manus och musiktexter till vännerna i Kungaskogen som blivit förskolans mest använda saga under 2000-talet.</p>
      <p>När Lisa inte skriver barnböcker arbetar hon som åklagare i stockholm.</p>
      <p>– Jag tror att det är väldigt viktigt att i tidig barndom lära sig att ha respekt för andra och känna och förstå empati. Det är så grundläggande hur man ska vara mot varandra. Förstår man hur man
      ska behandla människor i ens omgivning har man behållning av det livet ut. Jag ville göra en saga som tog upp det här på ett lättsamt sätt. Samtidigt ville jag att det skulle nå ut till barnen på
      flera nivåer så att de själva kunde vara med och delta i berättelsen. Därför blev också musiken ett viktigt inslag i sagan, säger Lisa.</p>
      <p>Lisa arbetar med nya sagor och texter till Kungaskogen på sin fritid.</p>
      <p>– Fler böcker och sånger planeras tillsammans med förlaget ILKA, fortsätter Lisa.</p>
      <p>Lisa bor som så många andra kreativa människor på Södermalm i Stockholm. På promenader i de gamla söderkvarteren och i vardagliga möten med människor hämtar Lisa nya idéer till manus.</p>

      <p>– Men ibland måste man åka iväg alldeles ensam någonstans för att kunna slutföra texter. Mitt sista manus till Kungaskogen färdigställde jag i en liten stuga på Fårö på Gotland. Här fanns lugnet och när jag tittade ut genom fönstret och såg Fårölandskapet såg jag också vad Snick och Snack och alla vännerna gjorde i Kungaskogen.</p>

      <p>– Jag är glad och stolt över att Kungaskogen har blivit ett så populärt och användarvänligt material för förskolan. Jag har också genom förlaget dagligen fått ta del av all den positiva respons
      som pedagoger och barn förmedlat. Särskilt glad är jag att så många berättat att barn som läst och arbetat med sagan faktiskt blivit lite snällare mot varandra!</p>
      <p>Lisa är uppväxt i en stor familj med fem syskon, där det alltid funnits liv och lek runt omkring.</p>
      <p>– Eftersom jag alltid gillat att skriva såg jag till att få sitta för mig själv ibland och fantisera ihop alla möjliga berättelser, dikter och sagor. Dock hade jag svårt att bestämma mig för vilket område
      som var min specialitet när det gällde att skriva, så jag påbörjade allt ifrån hästhistorier till krigsskildringar. Tills slut blev det barnböcker.</p>


    </div>

    <h3>Bilder</h3>
    <div className="press-image">
      <Image src="images/Ovrigt/snick_och_snack.jpg" />
      <Image src="images/Ovrigt/boken_kojan.jpg" />
      <Image src="images/Ovrigt/lisa.jpg" />
    </div>
    <p>Kontakta gärna förlaget så får ni en kod för mer material om böckerna om Snack & Snack och Vännerna i Kungaskogen.</p>
  </div>

);

export default press;
